document.addEventListener('DOMContentLoaded', function () {
  initializeTabs();

  // Listen for Shopify theme editor events
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      const selectedBlock = event.target;
      const tabView = selectedBlock.closest('.trv-tab-view');

      if (tabView) {
        let tabButton = null;

        // If a tab button is selected
        if (selectedBlock.classList.contains('trv-tab-button')) {
          tabButton = selectedBlock;
        }
        // If a tab panel is selected, find its corresponding button
        else if (selectedBlock.classList.contains('trv-tab-panel')) {
          const tabId = selectedBlock.id;
          tabButton = tabView.querySelector(`[data-tab="${tabId}"]`);
        }

        if (tabButton) {
          // Add a small delay to ensure proper rendering
          setTimeout(function () {
            // Simulate click on the tab button
            tabButton.click();

            // Scroll the tab into view if needed
            tabButton.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest',
            });
          }, 100);
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      // Optional: Handle block deselection if needed
      // This ensures proper cleanup when switching between blocks
    });

    document.addEventListener('shopify:section:select', function (event) {
      // Re-initialize tabs when section is selected
      const sectionElement = event.target;
      if (sectionElement.classList.contains('trv-tab-view')) {
        initializeTabs();
      }
    });
  }
});

function setActiveTab(tabId, scrollTimeout) {
  if (!tabId) return;
  scrollTimeout = Number(scrollTimeout);
  if (Number.isNaN(scrollTimeout) || scrollTimeout < 0) scrollTimeout = 0;
  tabId = tabId.replace('#', '').trim(); // Normalize
  const tabPanel = document.querySelector(`#${tabId}`);
  const tabButton = document.querySelector(`[data-tab="${tabId}"]`);
  if (!tabPanel || !tabButton) return;
  const tabView = tabPanel.closest('.trv-tab-view');
  // Remove active class from all tabs/buttons
  tabView.querySelectorAll('.trv-tab-button')?.forEach((btn) => btn.classList.remove('active'));
  tabView.querySelectorAll('.trv-tab-panel')?.forEach((div) => div.classList.remove('active'));
  // Add active for selected tab
  tabButton.classList.add('active');
  tabPanel.classList.add('active');
  const pageUrl = new URL(window.location.toString());
  if (tabPanel?.dataset?.defaultTab || tabPanel?.dataset?.bundlerTab === 'true') {
    pageUrl.hash = '';
    pageUrl.pathname = pageUrl.pathname.replace('#');
    history.replaceState(null, '', pageUrl.toString());
  } else {
    if (tabButton.dataset.bundlerTab !== 'true') {
      pageUrl.hash = tabId;
      history.replaceState(null, '', pageUrl.toString());
    }
  }
  if (scrollTimeout) {
    setTimeout(() => {
      tabButton.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }, scrollTimeout);
  }
}

function initializeTabs() {
  const tabViews = document.querySelectorAll('.trv-tab-view');
  const currenthash = window?.location?.hash;
  tabViews.forEach(function (tabView) {
    // Skip if already initialized
    if (tabView.dataset.initialized === 'true') {
      return;
    }

    const tabIds = [];
    const tabButtons = tabView.querySelectorAll('.trv-tab-button');
    const tabPanels = tabView.querySelectorAll('.trv-tab-panel');
    for (const panel of tabPanels) {
      const panelButton = document.querySelector(`[data-tab="${panel.id}"]`);
      const isBundlerTab = panel.dataset.bundlerTab === 'true';
      if (panel?.id) tabIds.push(panelButton?.dataset?.tab);
      // Remove empty tabs and set non-empty tabs buttons visible
      if (panel.querySelector('.shopify-block').textContent.trim() == '') {
        if (panelButton?.parentElement?.classList.contains('shopify-block')) {
          if (!window?.Shopify?.designMode && panelButton.dataset.allowEmpty === 'false') {
            if (!isBundlerTab) {
              panelButton.parentElement.remove();
              panel.remove();
            } else {
              panelButton.parentElement.style.display = 'none';
            }
          } else {
            if (!isBundlerTab) {
              panelButton.style.opacity = 1;
            } else {
              panelButton.parentElement.style.display = 'none';
            }
          }
        }
      } else {
        // Tab have content
        if (!isBundlerTab) {
          panelButton.style.opacity = 1;
        } else {
          panelButton.parentElement.style.display = 'none';
          // panelButton.style.parentElement.display = 'none';
        }
      }
    }

    // Filter to only direct children of this tabView
    const directTabButtons = Array.from(tabButtons).filter(function (button) {
      return button.closest('.trv-tab-view') === tabView;
    });

    const directTabPanels = Array.from(tabPanels).filter(function (panel) {
      return panel.closest('.trv-tab-view') === tabView;
    });

    // Ensure first tab is active if no tab is marked as active
    const activeButton = directTabButtons.find((btn) => btn.classList.contains('active'));
    const activePanel = directTabPanels.find((panel) => panel.classList.contains('active'));

    if (!activeButton && directTabButtons.length > 0) {
      directTabButtons[0].classList.add('active');
    }

    if (!activePanel && directTabPanels.length > 0) {
      directTabPanels[0].classList.add('active');
    }

    directTabButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setActiveTab(button?.dataset.tab, 0);
      });
    });

    // check for links with tabid and add event listener
    const links = document.querySelector('main')?.querySelectorAll('a[href]');
    if (links) {
      for (const link of links) {
        let linkHref = link.getAttribute('href');
        if (!linkHref.includes('#')) continue;
        try {
          if (!linkHref.includes('://'))
            linkHref = `${window.location.protocol}//${window.location.hostname}${linkHref.startsWith('/') ? linkHref : window.location.pathname + linkHref}`;
          const linkUrl = new URL(linkHref);
          const tabId = linkUrl.hash.replace('#', '').trim();
          if (tabIds.includes(tabId)) {
            link.addEventListener('click', (e) => {
              e.preventDefault();
              setActiveTab(tabId, 50);
            });
          }
        } catch (e) {
          console.log('invalid url', linkHref, link);
        }
      }
    }

    if (currenthash) {
      setActiveTab(currenthash, 300);
    }
    // Mark as initialized
    tabView.dataset.initialized = 'true';
  });

  // If not fired through click event on tab or link
  addEventListener('hashchange', (event) => {
    if (!event?.newURL) return;
    const hash = new URL(event.newURL)?.hash;
    if (!hash || document.querySelector(hash)?.classList.contains('active')) return;
    setActiveTab(hash, 50);
  });

  // This event will be fired whenever the Bundler app is loaded
  document.addEventListener('bundler:loaded', function (e) {
    const currentProductUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    const bundleUrls = window?.bndlr?.getProductUrls();
    if (Array.isArray(bundleUrls)) {
      if (bundleUrls.includes(currentProductUrl)) {
        const bundlerTabButton = document.querySelector('[data-bundler-tab="true"].trv-tab-button');
        bundlerTabButton.parentElement.style.display = 'unset';
        bundlerTabButton.style.opacity = '1';
        const tabId = bundlerTabButton?.dataset?.tab;
        if (tabId) {
          setActiveTab(tabId, 0);
        }
      }
    }
  });
}
